import { tAgendaProviderProps } from '../Agenda.types';
import useAgendaTemplateView from '../hooks/agendaTemplateView.hook';
import { AgendaTemplatesContext } from './agendaTemplates.context';

export function AgendaTemplatesProvider(props: tAgendaProviderProps) {
  const agendaTemplates = useAgendaTemplateView();

  return (
    <AgendaTemplatesContext.Provider value={agendaTemplates}>
      {props.children}
    </AgendaTemplatesContext.Provider>
  );
}
